var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33092 17.5005C3.39735 17.5086 3.4645 17.5086 3.53092 17.5005L6.86426 16.6672C7.01213 16.632 7.14757 16.5571 7.25592 16.4505L17.4976 6.17553C17.808 5.86326 17.9822 5.44084 17.9822 5.00053C17.9822 4.56022 17.808 4.1378 17.4976 3.82553L16.1809 2.50053C16.0261 2.34557 15.8423 2.22264 15.64 2.13876C15.4377 2.05489 15.2208 2.01172 15.0018 2.01172C14.7827 2.01172 14.5659 2.05489 14.3635 2.13876C14.1612 2.22264 13.9774 2.34557 13.8226 2.50053L3.58092 12.7422C3.47325 12.851 3.39571 12.986 3.35592 13.1339L2.52259 16.4672C2.49264 16.575 2.48471 16.6878 2.49928 16.7987C2.51385 16.9097 2.55062 17.0166 2.60739 17.113C2.66416 17.2094 2.73978 17.2935 2.82973 17.36C2.91967 17.4266 3.02211 17.4744 3.13092 17.5005C3.19735 17.5086 3.2645 17.5086 3.33092 17.5005ZM14.9976 3.67553L16.3226 5.00053L14.9976 6.32553L13.6809 5.00053L14.9976 3.67553ZM4.92259 13.7589L12.4976 6.17553L13.8226 7.50053L6.23926 15.0839L4.48092 15.5172L4.92259 13.7589Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPencil);
export default __webpack_public_path__ + "static/media/bx-pencil.90ef8a4e1e511c71e8ec7c60932010ed.svg";
export { ForwardRef as ReactComponent };